import { Flex, Typography } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';
import { styled } from 'styled-components';

const { Text } = Typography;

export const FooterContainer = styled(Flex).attrs({
  justify: 'space-between',
  align: 'center',
})`
  padding: 12px 16px;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
`;

export const FooterText = styled(Text)`
  color: rgba(0, 0, 0, 0.88);
`;

export const LogoutIcon = styled(LogoutOutlined)`
  color: rgba(0, 0, 0, 0.88);
  cursor: pointer;
`;
